export default __webpack_public_path__ + "MERN-logo.png";